/**
 * Registers the Firebase messaging service worker and forces an update check
 * on every app load so changes to firebase-messaging-sw.js deploy immediately.
 */
const tellWorkerToSkipWaiting = (worker: ServiceWorker | null): void => {
    worker?.postMessage({ type: 'SKIP_WAITING' });
};

export const registerAndUpdateSw = (): void => {
    if (!navigator.serviceWorker) {return;}

    // `updateViaCache: 'none'` bypasses HTTP cache when fetching the SW
    // script so a new deploy is picked up even when the cached copy is fresh.
    navigator.serviceWorker
        .register('/firebase-messaging-sw.js', { updateViaCache: 'none' })
        .then(reg => {
            // If a new worker is already waiting, activate it now.
            tellWorkerToSkipWaiting(reg.waiting);

            // Any time an update is found, push it through to active as soon
            // as it finishes installing — no tab-reload required.
            reg.addEventListener('updatefound', () => {
                const installing = reg.installing;
                if (!installing) {return;}
                installing.addEventListener('statechange', () => {
                    if (installing.state === 'installed' && reg.waiting) {
                        tellWorkerToSkipWaiting(reg.waiting);
                    }
                });
            });

            return reg.update().then(() => {
                tellWorkerToSkipWaiting(reg.waiting);
            });
        })
        .catch(err => console.error('SW register/update failed:', err));
};
